import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';

// Declare gtag function type
declare global {
  interface Window {
    gtag?: (command: string, action: string, parameters: Record<string, string>) => void;
  }
}

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    
    // Enable Google Analytics, Google Ads, and other tracking
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted',
        'functionality_storage': 'granted',
        'personalization_storage': 'granted',
        'security_storage': 'granted'
      });
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
    
    // Keep only essential cookies
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied',
        'ad_storage': 'denied',
        'functionality_storage': 'denied',
        'personalization_storage': 'denied',
        'security_storage': 'granted'
      });
    }
  };

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div role="dialog" aria-label="Preferințe cookie" className="fixed bottom-4 left-4 right-4 z-50 rounded-[1.5rem] border border-blue-100 bg-white p-5 shadow-lift">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-start gap-3 flex-1">
            <Cookie className="h-6 w-6 text-blue-600 mt-1 flex-shrink-0" />
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-2">Cookie-uri și confidențialitate</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Utilizăm cookie-uri pentru a îmbunătăți experiența dvs. pe site, pentru a analiza traficul 
                și pentru a vă oferi conținut personalizat. Cookie-urile ne ajută să înțelegem cum 
                interacționați cu site-ul nostru și să vă oferim o experiență mai bună.
                De asemenea, folosim Google Analytics și Google Ads pentru promovare.
              </p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-2 md:ml-4">
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors duration-200"
            >
              Doar Esențiale
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors duration-200"
            >
              Accept toate
            </button>
          </div>
          
          <button
            onClick={handleClose}
            aria-label="Închide mesajul despre cookie-uri"
            className="absolute top-4 right-4 md:relative md:top-0 md:right-0 text-gray-400 hover:text-gray-600 transition-colors duration-200"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="mt-3 pt-3 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            Pentru mai multe informații, consultați{' '}
            <a href="/terms-conditions" className="text-blue-600 hover:text-blue-800 underline">
              Termenii și Condițiile
            </a>{' '}
            noastre.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
